//Componentes generales
import React, { useState, useContext, useRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { NavLink, useNavigate } from "react-router-dom";
import Routes_gral from "../../utils/Routes_gral";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// Alertas
import Swal from "sweetalert2";

//Imagenes
import logoG4 from "../../images/LOGO-BLANCO.png";

//Estilos
import "./SignUp.css";

//Contexto
import authContext from "../../context/authentication/authContex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//Iconos
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

function SignUp(props) {
  const navigate = useNavigate();

  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { crearCuenta } = aContext;
  const [showTerms,setShowTerms] = useState(false);

  const recaptcha = useRef(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const [cargando, setCargando] = useState(false);

  const [width,setWidth] = useState(window.innerWidth)

  //State
  const [usuarioState, setUsuarioState] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    userName: "",
    tenantId: "",
    password: "",
    repeatPassword: "",
  });

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleRepeatPasswordVisibility = () => {
    setShowRepeatPassword(!showRepeatPassword);
  };

  /*
            Función que muestra una alerta popIt del mensaje seteado en el contexto. 
  */
  const alerta = (mensaje, typeIcon) => {
    return Swal.fire({
      text: mensaje,
      icon: typeIcon,
      confirmButtonText: "OK",
    });
  };

  /* 
        Función que controla el evento de Registro (Botón). En el mismo se verifica el catpcha y si el correo y alias de empresa ya se encuentran resgistrados. Luego envía correo de verificación.
  */
  const onSubmit = async () => {
  
    const captchaToken = recaptcha.current.getValue();
    if (!captchaToken) {
      alerta("Por favor, complete el captcha.", "warning");
      return;
    }
    
    try {
      function hasWhitespaceOrLowercase(str) {
        const hasWhitespace = /\s/.test(str);
        const hasLowercase = /[a-z]/.test(str);
        return hasWhitespace || hasLowercase;
      }

      if(hasWhitespaceOrLowercase(usuarioState.tenantId)){
        alerta(
          "Alias de Empresa debe ir todo junto y en mayúsculas",
          "warning"
        );
        return;
      }

      if (
        usuarioState.fullName.trim() == "" ||
        usuarioState.email.trim() == "" ||
        usuarioState.userName.trim() == "" ||
        usuarioState.password.trim() == "" ||
        usuarioState.repeatPassword.trim() == ""
      ) {
        alerta(
          "Debe completar todos los campos que son obligatorios",
          "warning"
        );
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(usuarioState.email)) {
        alerta("Ingrese un correo electrónico válido.", "warning");
        return;
      }

      if (
        /[a-z]/.test(usuarioState.userName) ||
        /\s/.test(usuarioState.userName)
      ) {
        alerta(
          "El alias de la empresa debe escribirse todo junto y en mayúsculas.",
          "warning"
        );
        return;
      }

      if (usuarioState.password !== usuarioState.repeatPassword) {
        alerta("Las contraseñas deben coincidir.", "warning");
        return;
      }

      if (
        !/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}$/.test(
          usuarioState.password
        )
      ) {
        alerta(
          "La contraseña debe tener al menos 8 caracteres, incluyendo una letra mayúscula, una minúscula y un número.",
          "warning"
        );
        return;
      }

      setShowTerms(true);
      
    } catch (error) {
      setCargando(false);
      console.log("Error en crear cuenta:", error);

      const mensajeError = String(
        error?.response?.data?.message ||
          error?.response?.data?.msg ||
          error?.message ||
          "Error desconocido."
      );

      setCargando(false);
      recaptcha.current.reset();
      const mensajeFinal = "ERROR AL CREAR CUENTA: " + mensajeError;
      alerta(mensajeFinal, "warning");
    }
  };

  const registerAfterTermsConfirmed = async () => {
    try {
      setCargando(true);
      const captchaToken = recaptcha.current.getValue();

      const resp = await crearCuenta(usuarioState, captchaToken);

      if (!resp) {
        setCargando(false);
        throw Error;
      }
      if (recaptcha.current) {
        recaptcha.current.reset();
      }

      setCargando(false);
      aContext.limpiarError();
      await alerta(
        "Registro exitoso, revise su casilla de email para confirmar su correo. Si no ve el mensaje, recuerde revisar la carpeta de spam o correo no deseado.",
        "success"
      ).then(() => {
        setUsuarioState({
          fullName: "",
          email: "",
          phoneNumber: "",
          userName:'',
          tenantId: "",
          password: "",
          repeatPassword: "",
        });
        setTimeout(() => {
          navigate(Routes_gral.login);
        }, 200);
      });
    } catch (error) {
      setCargando(false);
      console.log("Error en crear cuenta:", error);

      const {errors} = error?.response?.data;

      if(errors){
        Swal.fire({
          title:'Ops!',
          html:errors[0]?.msg?.replace(/\n/g, '<br>'),
          icon:'error'
        })
      }else{
        const mensajeError = String(
            error?.response?.data?.message ||
            error?.response?.data?.msg ||
            error?.message ||
            "Error desconocido."
        );

        setCargando(false);
        recaptcha.current.reset();
        const mensajeFinal = "ERROR AL CREAR CUENTA: " + mensajeError;
        alerta(mensajeFinal, "warning");
      }
    }
  }

  /* 
        Manejador que setea valores en los respectivos campos por los ingresados.
            Donde e.target.value es el texto ingresado.
  */
  const handlerInput = (e, campo) => {
    //setUsuarioState({ ...usuarioState, [campo]: e.target.value });
    setUsuarioState((prevState) => {
      let newUser = {...prevState};
      if(campo == 'tenantId'){
        let tenant = e.target.value.trim().toUpperCase();
        newUser['userName'] = tenant;
        newUser[campo] = tenant;
      }else{
        newUser[campo] = e.target.value;
      }
      return newUser
    });
  }

  useEffect(()=>{
    window.addEventListener('resize',()=>setWidth(window.innerWidth));
    return window.removeEventListener('resize',()=>setWidth(window.innerWidth));
  },[width]);

  const TermsConditionsModal = ({registerAfterTermsConfirmed, setShowTerms}) => {

    const [readedAndChecked,setReadedAndChecked] = useState(false);
    
    const accept = () => {
      if(readedAndChecked){
        setShowTerms(false);
        registerAfterTermsConfirmed();
      }
      else Swal.fire("Para avanzar debe tildar que entiende y acepta los términos y condiciones","",'warning')
    } 

    return <div className="termsModalContainer">
    <div className="termsContainer">
      <button className="minimizarBtn" onClick={()=>setShowTerms(false)}>X</button>
      <h3>Términos de Uso - Xertux</h3>
      <h5>Al registrarte y utilizar la aplicación Xertux, aceptas las siguientes condiciones, que regulan tu relación con nosotros:</h5>
      <div className="bodyTems">
        <div className="section">
          <p>
            <b>1. Período de Prueba Gratuito y Acceso a Contenido</b>
            <br/>
            Al crear tu cuenta en Xertux, te otorgamos un acceso libre y gratuito por un período de 30 (treinta) días corridos a partir de la fecha de tu registro, pudiendo mantener además 5 usuarios habilitados. Este período está diseñado para que puedas conocer y familiarizarte con las funcionalidades básicas de la aplicación. Durante estos 30 días, tendrás disponible de forma gratuita más de 20 videos específicos que te guiarán en el nivel3 de implementación inicial y te ayudarán a aprovechar al máximo tu experiencia con Xertux. 
          </p>
        </div>
        <div className="section">
          <p>
              <b>2. Finalización del Acceso Gratuito y Continuidad del Servicio</b><br/>
              Una vez que el plazo de 30 (treinta) días de prueba gratuita haya concluido, tu acceso a la aplicación Xertux finalizará automáticamente. Para poder seguir utilizando Xertux y acceder a todas sus funcionalidades y contenidos deberás optar por suscribirte a una de nuestras versiones pagas. 
          </p>
        </div>
        <div className="section">
          <p>
            <b>3. Tratamiento de Datos Personales en la Versión Gratuita</b><br/>
            Con el objetivo de permitir una eventual reactivación de tu cuenta o suscripción posterior, tus datos personales asociados a la versión gratuita serán almacenados en nuestras bases de datos por un período de 60 (sesenta) días contados a partir de la fecha de finalización de tu acceso gratuito. Una vez transcurrido este plazo, y si no has adquirido una suscripción paga, tus datos personales serán eliminados de forma permanente y definitiva de nuestros sistemas, sin posibilidad de recuperación.
          </p>
        </div>
        <div className="section">
          <p>
            <b>4. Protección de Datos Personales (Ley Nacional N° 25.326)</b><br/>
            En Xertux nos comprometemos a proteger tu privacidad. Cumplimos con lo establecido en la Ley Nacional de Protección de Datos Personales N° 25.326 y sus normas complementarias. Esto significa que tus datos serán tratados con la debida confidencialidad y solo para las finalidades informadas. Tenés derecho a solicitar el acceso, rectificación, actualización o supresión de tus datos personales almacenados en nuestras bases. Para ejercer estos derechos, podés contactarnos a través de soporte@g4consulting.com.ar 
          </p>
        </div>
        <div className="section">
          <p>
            <b>5. Cumplimiento de la Ley de Defensa del Consumidor (Ley N° 24.240)</b><br/>
            Como proveedores de servicios, nos esforzamos por cumplir con las disposiciones de la Ley de Defensa del Consumidor N° 24.240. Nos comprometemos a brindarte información clara, detallada y veraz sobre nuestras condiciones de uso y los servicios ofrecidos (Artículo 4° LDC). Asimismo, garantizamos un trato digno y equitativo en todas nuestras interacciones (Artículo 8° bis LDC).
          </p>
        </div>
        <div className="section">
          <p>
            <b>6. Naturaleza del Contrato y Protección Legal</b><br/>
            La relación que se establece con Xertux durante el período gratuito (30 días) se considera un contrato de cortesía o prueba. Si bien no se encuadra dentro del "orden público" de la Ley de Defensa del Consumidor en sus aspectos más protectores (dada su gratuidad y naturaleza de prueba), ambas partes nos obligamos a actuar de buena fe, conforme lo establece el Artículo 961 del Código Civil y Comercial de la Nación.
            Sin embargo, al suscribirte a la versión paga de Xertux, celebras un contrato de carácter oneroso (con costo), el cual se encuentra plenamente protegido por la Ley de Defensa del Consumidor N° 24.240 y por las normas aplicables del Código Civil y Comercial de la Nación.
            En este sentido, y para tu conocimiento, destacamos algunos artículos relevantes:
            <br/><b className="pointed"><i>Código Civil y Comercial de la Nación (Ley N° 26.994):</i></b>
            Artículo 961 (Buena Fe): "Los contratos deben celebrarse, interpretarse y ejecutarse de buena fe. Obligan no sólo a lo que está formalmente expresado, sino a todas las consecuencias que puedan considerarse comprendidas en ellos, con los alcances en que razonablemente se habría obligado un contratante cuidadoso y previsor."
            Artículo 1104 (Contratos celebrados a distancia): Refiere a los contratos concluidos entre un proveedor y un consumidor con el uso exclusivo de medios de comunicación a distancia, como es el caso de una suscripción online.
            Artículo 1106 (Utilización de medios electrónicos): Establece que los contratos deben ser válidos aun cuando se utilicen medios electrónicos.
            Artículo 1107 (Información sobre revocación): Obliga a informar al consumidor sobre su derecho a revocar.
            <br/><b  ><i className="pointed">Ley de Defensa del Consumidor (Ley N° 24.240):</i></b>
            Artículo 4° (Deber de Información): El proveedor está obligado a suministrar al consumidor en forma cierta, clara y detallada todo lo relacionado con las características esenciales de los bienes y servicios que provee, y las condiciones de su comercialización.
            Artículo 10 ter (Revocación de Aceptación): En los contratos celebrados fuera de los establecimientos comerciales y a distancia, el consumidor tiene el derecho irrenunciable de revocar la aceptación dentro de los diez (10) días corridos contados a partir de la fecha en que se celebra el contrato
          </p>
        </div>
      </div>

      <div className="inputGroupSignUp">
        <input type="checkbox" onChange={e => setReadedAndChecked(e.target.checked)}/>
        <label>Entiendo y acepto los términos y condiciones</label>
      </div>

      <button className="acceptBtn" onClick={accept}>ACEPTAR</button>
    </div>
    </div>

  }

  return (
    <div className="container-registro">
      <div className="card-registro">
        <div className="containerRegistroTitulo">
          <p>Crear una cuenta</p>
        </div>
        <p className="label-campo-obligatorio" style={{paddingLeft:'10%'}}>*Campo requerido</p>
        <div className="containerFormRegistro">
          <div className="containerRegistroInput  obligatorio">
            <input
              className="textRegistroInput"
              id="fullName"
              placeholder="Nombre y Apellido"
              type="text"
              name="fullName"
              value={usuarioState.fullName}
              onChange={(e) => handlerInput(e, "fullName")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onSubmit();
                }
              }}
            />
            <span className="asterisco">*</span>
          </div>
          <div className="containerRegistroInput  obligatorio">
            <input
              className="textRegistroInput"
              id="email"
              placeholder="Email"
              type="email"
              name="email"
              value={usuarioState.email}
              onChange={(e) => handlerInput(e, "email")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onSubmit();
                }
              }}
            />
            <span className="asterisco">*</span>
          </div>
          <div
            className="containerRegistroInput"
            style={{ position: "relative" }}
          >
            <PhoneInput
              ///country={'ar'}
              value={usuarioState.phoneNumber}
              onChange={(phone) =>
                handlerInput({ target: { value: phone } }, "phoneNumber")
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onSubmit();
                }
              }}
              format={(number) => {
                // Raw number without non-digits
                const raw = number.replace(/[^\d]/g, '');
            
                // Basic format without parentheses
                return raw.replace(/^(\d{2})(\d{2})(\d{4,})$/, '$1 $2 $3');
              }}
              inputProps={{
                placeholder: "Teléfono (Opcional)",
                name: "phoneNumber",
                required: false,
                autoFocus: false,
                className: "textRegistroInput phoneNumber",
              }}
              masks={{ ar: '... ... ....' }} 
              enableNivel1Codes={false}
            />
          </div>
          <div
            className="containerRegistroInput  obligatorio"
            style={ { marginTop: width > 1550 ? "20px" : '5px' }}
          >
            <input
              className="textRegistroInput"
              id="userName"
              placeholder="Alias de Empresa (escribir todo junto y en mayúsculas)"
              type="text"
              name="userName"
              value={usuarioState.tenantId}
              onChange={(e) => handlerInput(e, "tenantId")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onSubmit();
                }
              }}
            />
            <span className="asterisco">
              *
            </span>
            {width > 1550 && <div className="placeholderSimulado">
              <span className="guiaRegistro">
                (Escribir todo junto y en mayúsculas)
              </span>
            </div>}
          </div>
          <div
            className="containerRegistroInput obligatorio"
            style={{ position: "relative" }}
          >
            <input
              className="textRegistroInput"
              id="password"
              placeholder="Contraseña"
              type={showPassword ? "text" : "password"}
              name="password"
              value={usuarioState.password}
              onChange={(e) => handlerInput(e, "password")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onSubmit();
                }
              }}
            />
            <div className="eye" onClick={togglePasswordVisibility}>
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </div>
            <span className="asterisco">*</span>
          </div>
          <div
            className="containerRegistroInput obligatorio"
            style={{ position: "relative" }}
          >
            <input
              className="textRegistroInput"
              id="repeatPassword"
              placeholder="Repetir contraseña"
              type={showRepeatPassword ? "text" : "password"}
              name="repeatPassword"
              value={usuarioState.repeatPassword}
              onChange={(e) => handlerInput(e, "repeatPassword")}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  onSubmit();
                }
              }}
            />
            <div className="eye" onClick={toggleRepeatPasswordVisibility}>
              <FontAwesomeIcon icon={showRepeatPassword ? faEyeSlash : faEye} />
            </div>
            <span className="asterisco">*</span>
          </div>
          
        </div>
        
        <div className="validationAndSubmitDiv">
          <div style={{ marginTop: "10px" }}>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_CAPTCHA_KEY}
              ref={recaptcha}
            />
          </div>
          <div className="btnSubmitRegistroContainerStyle">
            {cargando == false ? (
              <>
                <button
                  id="myBtn"
                  className="btnSubmitRegistroStyle"
                  onClick={onSubmit}
                >
                  Registrarte
                </button>
                <div className="alreadyHaveAccountDiv" style={{ marginTop: "20px", display: "flex" }}>
                  <p style={{ color: "black", width:'fitContent'}}>¿Tienes una cuenta?</p>
                  <NavLink
                    onClick={() => aContext.limpiarError()}
                    to={Routes_gral.login}
                    style={{ display: "inline", marginLeft: "5px" }}
                  >
                    Ingresar
                  </NavLink>
                </div>
              </>
            ) : (
              <div>
                <header>
                  <h4 style={{ color: "black", marginTop: "10px" }}>
                    Enviando email...
                  </h4>
                </header>
              </div>
            )}
          </div>

        </div>
      </div>
      {showTerms && <TermsConditionsModal registerAfterTermsConfirmed={registerAfterTermsConfirmed} setShowTerms={setShowTerms}/>}
    </div>
  );
}

export default SignUp;